import React, { useState } from 'react';
import UIModal from '@/components/shared/UIModal';
import UIInputSearch from '@/components/shared/UIInputSearch';
import UITenantTable from '@/components/shared/Chat/UITenantTable';
import UIPaginator from '@/components/shared/UIPaginator';
import type { TenantData } from '@/components/shared/Chat/UITenantTable';

export interface NewConversationModalProps {
  /**
   * Чи відкрите модальне вікно
   */
  isOpen?: boolean;

  /**
   * Обробник закриття модального вікна
   */
  onClose?: () => void;

  /**
   * Обробник вибору тенанта для створення розмови
   */
  onTenantSelect?: (tenantId: number) => void;

  /**
   * Обробник кліку на кнопку інформації
   */
  onInfoClick?: (tenantId: number) => void;

  /**
   * Список тенантів
   */
  tenants?: TenantData[];

  /**
   * Загальна кількість тенантів
   */
  totalItems?: number;

  /**
   * Кількість елементів на сторінці
   */
  itemsPerPage?: number;

  /**
   * Поточна сторінка
   */
  currentPage?: number;

  /**
   * Обробник зміни сторінки
   */
  onPageChange?: (page: number) => void;

  /**
   * Обробник пошуку
   */
  onSearch?: (searchTerm: string) => void;

  /**
   * Додатковий CSS клас
   */
  className?: string;
}

const NewConversationModal: React.FC<NewConversationModalProps> = ({
                                                                     isOpen = false,
                                                                     onClose = () => {},
                                                                     onTenantSelect = (id) => console.log('Tenant selected:', id),
                                                                     onInfoClick = (id) => console.log('Info clicked:', id),
                                                                     tenants = [],
                                                                     totalItems = 127,
                                                                     itemsPerPage = 10,
                                                                     currentPage = 1,
                                                                     onPageChange = (page) => console.log('Page changed:', page),
                                                                     onSearch = (term) => console.log('Search:', term),
                                                                     className = '',
                                                                   }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (value: string) => {
    setSearchTerm(value);
    onSearch(value);
  };

  const handleSearchClear = () => {
    setSearchTerm('');
    onSearch('');
  };

  const handleTenantClick = (tenantId: number) => {
    onTenantSelect(tenantId);
    onClose(); // Закриваємо модальне вікно після вибору
  };

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  return (
    <UIModal
      isOpen={isOpen}
      onClose={onClose}
      title="New Conversation"
      size="xlarge"
      className={`new-conversation-modal-wrapper ${className}`}
    >
      {/* Контейнер з гнучкою висотою */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: '500px',
        overflow: 'hidden',
        width: '100%'
      }}>
        {/* Пошук */}
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          padding: '0px',
          gap: '8px',
          width: '100%',
          height: '72px',
          flexShrink: 0,
        }}>
          <UIInputSearch
            placeholder="Search"
            size="medium"
            fullWidth
            value={searchTerm}
            onChange={handleSearchChange}
            onClear={handleSearchClear}
          />
        </div>

        {/* Таблиця тенантів */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          flex: 1,
          overflow: 'hidden',
          minHeight: 0,
        }}>
          <UITenantTable
            tenants={tenants}
            onTenantClick={handleTenantClick}
            onInfoClick={onInfoClick}
            showHeader={true}
            variant="compact"
          />
        </div>

        {/* Навігація */}
        {totalPages > 1 && (
          <div style={{
            flexShrink: 0,
            paddingTop: '16px',
            width: '100%'
          }}>
            <UIPaginator
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
              pageInfo={`${currentPage} of ${totalPages}`}
            />
          </div>
        )}
      </div>
    </UIModal>
  );
};

export default NewConversationModal;